(function(){
  var c = document.getElementById('way-field');
  if(!c) return;
  var ctx = c.getContext('2d');

  var CELL = 11;
  var GAP  = 1;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var cols, rows, dpr;

  function size(){
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    c.width  = Math.floor(window.innerWidth  * dpr);
    c.height = Math.floor(window.innerHeight * dpr);
    ctx.setTransform(dpr,0,0,dpr,0,0);
    cols = Math.ceil(window.innerWidth  / CELL) + 1;
    rows = Math.ceil(window.innerHeight / CELL) + 1;
  }

  var A = [6, 12, 24];
  var B = [122, 190, 255];

  function draw(t){
    ctx.fillStyle = '#05080D';
    ctx.fillRect(0,0,window.innerWidth,window.innerHeight);

    for(var y=0; y<rows; y++){
      for(var x=0; x<cols; x++){
        var w1 = Math.sin((x * 0.16) + (y * 0.09) - t * 1.15);
        var w2 = Math.sin((x * 0.055) - (y * 0.13) - t * 0.62);
        var v = (w1 * 0.6 + w2 * 0.4) * 0.5 + 0.5;
        v = Math.pow(v, 2.1);

        var r = A[0] + (B[0]-A[0]) * v;
        var g = A[1] + (B[1]-A[1]) * v;
        var b = A[2] + (B[2]-A[2]) * v;

        ctx.fillStyle = 'rgb('+(r|0)+','+(g|0)+','+(b|0)+')';
        ctx.fillRect(x*CELL, y*CELL, CELL-GAP, CELL-GAP);
      }
    }
  }

  function loop(now){
    draw(now / 1000);
    window.requestAnimationFrame(loop);
  }

  window.addEventListener('resize', function(){ size(); if(still) draw(0); });
  size();
  if(still){ draw(0); } else { window.requestAnimationFrame(loop); }
})();
